<template lang="pug">
  #hello
    #bg
    #content
      .welcome
        .l-logo
          .c-logo
            // img(src="../assets/printa-logo.png")
          .logo-hi
            p Печать на все случаи
        .l-social
          svg.icon-inst(onclick="location.href = 'http://www.instagram.com/printa36'")
            include ../assets/instagram-with-circle.svg
          svg.icon-vk(onclick="location.href = 'http://www.vk.com/printa36'")
            include ../assets/vk-with-circle.svg
        .c-line
        .l-contacts
          // p Печать на футболках, холсте, в Воронеже
          a(href="tel:+7-951-549-67-62") +7-951-549-67-62
          a(href="tel:") 
          // p 

</template>

<script>
export default {

  name: 'HelloPrinta',

  data () {
    return {

    }
  }
}
</script>

<style lang="stylus">
@font-face {
  font-family: 'OpinionExtraCond';
  font-style: normal;
  font-weight: 300;
  src: url('../assets/Opinion Pro ExtraCondensed Light.otf') format('opentype');
}
#hello
  position relative
  // display flex
  // justify-content center
  // align-items center
  text-align center
  padding 0
  width 100vw
  height 100vh
  background-color black
  color white
#bg
  position absolute
  width 100%
  height 100%
  background-color black
  background-image url('../assets/fasion-bg.jpg')
  background-position center
  background-size cover
  opacity .3
  -webkit-filter blur(2px)
#content
  position absolute
  display flex
  flex-direction column
  justify-content center
  align-items center

  width 100vw
  height 80vh

  // background-color red
.welcome
  display flex
  flex-direction column
  // position absolute
  // width 100%
  justify-content center
  align-items center
.l-logo
  position relative
  display flex
  width 220px
  height 90px

  align-items center
  // box-sizing border-box
  // border 1px solid green
.c-logo
  position relative
  display inline-block
  // justify-content center
  // align-items center
  // width 150px
  vertical-align middle
  width 100%
  height 100%
  opacity .75
  background-color white
  // border 1px solid red
  // box-sizing border-box
  background-image url('../assets/printa-logo.png')
  background-position center
  background-size 150px
  background-repeat no-repeat
  img
    // display inline-block
    // position absolute
    // height 100px
.logo-hi
  display inline-block
  background-color black
  width 70px
  height 100%
  padding top=0px right=10px bottom=5px left=10px
  vertical-align middle
  box-sizing border-box
  opacity .75
  font-family 'OpinionExtraCond'
  // text-align left
  // vertical-align baseline
  font-size 14pt
  font-weight 600
.l-social
  display flex
  flex-direction row
  justify-content center
  align-items center
  // margin top=25px right=0px bottom=25px left=0px
  // background-color white
.icon-inst, .icon-vk
  margin top=25px right=8px bottom=0 left=8px
  width 36px
  height 36px
  fill white
  opacity .75
  cursor pointer

.c-line
  // margin top=20px
  // border-bottom 1px solid white
  opacity .6

.l-contacts
  margin top=25px
  width 60vw
  font-family 'OpinionExtraCond'
  font-size 14pt
  a
    display block
    margin 10px

</style>
